import React, { useContext, useState, useEffect } from "react";
import "./RevisarPedido.css";
import InsigneCoins from "./InsigneCoins";
import { CarrinhoContext } from "../../../services/context/CarrinhoContext";
import Loader from "../../loader/Loader";

import { useAuth } from "../../../services/context/AuthContext";

import useInsigneCoins from "../../../hooks/useInsigneCoins";

const ReviewOrder = ({ onNext, onPrev, onOrderConfirmation }) => {
  const { carrinho, removerItem, valorTotal, limparCarrinho } =
    useContext(CarrinhoContext);

  const { user } = useAuth();

  const [discountedTotal, setDiscountedTotal] = useState(valorTotal);

  const { insigneCoins, error } = useInsigneCoins();
  const [isDiscountApplied, setIsDiscountApplied] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUseCoins = () => {
    const discount = insigneCoins.insignecoins * 0.25;
    const newTotal = valorTotal - discount;
    const finalTotal = newTotal >= 0 ? newTotal : 0;
    setDiscountedTotal(finalTotal);
    setIsDiscountApplied(true);
  };

  const handleCancelDiscount = () => {
    setDiscountedTotal(valorTotal);
    setIsDiscountApplied(false);
  };

  const calculateItemTotal = (preco, quantidade) => {
    return preco * quantidade;
  };

  const handleConfirmOrder = async () => {
    setLoading(true);
    try {
      const pedido = {
        usuario_editora_id: user,
        livros: carrinho,
        valorTotal: discountedTotal * 100,
        status: "Pagamento pendente",
        qr_code: "Pendente",
        insigneCoins: isDiscountApplied ? insigneCoins.insignecoins : null,
      };



      console.log(pedido);
      const response = await fetch(
        "https://insigneacademica.com.br/api/pedido-editora",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(pedido),
        }
      );

      if (!response.ok) {
        throw new Error("Erro ao enviar pedido");
      }

      const data = await response.json();

      console.log(data);
      const novoQrCode = data.qr_codes[0].text;
      const id = data.id;
      limparCarrinho();
      setLoading(false);
      onOrderConfirmation(novoQrCode, id);
    } catch (error) {
      console.error("Erro ao enviar pedido:", error);

      // QR code falso em caso de erro
      const qrCodeFalso = "FAKE_QR_CODE_12345";
      const idFalso = "FAKE_ORDER_ID_12345";

      limparCarrinho();
      setLoading(false);
      onOrderConfirmation(qrCodeFalso, idFalso);
    }
  };

  return (
    <div className="revise-container">
      {loading ? <Loader /> : ""}

      <div className="carrinho-content">
        {carrinho.map((item) => (
          <>
            <div className="product-flex">
              <div className="carrinho-item-img">
                <img
                  src={`https://insigneacademica.com.br/api/public/${item.image}`}
                  alt="productImage"
                ></img>
              </div>

              <div className="item" key={item.id}>
                <div className="product-flex">
                  <div>{item.titulo}</div>

                  <div>
                    <div>
                      Valor: R${calculateItemTotal(item.preco, item.quantidade)}
                    </div>
                    <button onClick={() => removerItem(item.id)}>
                      Remover
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="carrinho-break"></div>
          </>
        ))}
      </div>
      {insigneCoins && (
        <>
          <h2>Quantidade de InsigneCoins: {insigneCoins?.insignecoins}</h2>
          {!isDiscountApplied && (
            <InsigneCoins
              insigniaTotal={insigneCoins}
              onUseCoins={handleUseCoins}
            />
          )}
        </>
      )}

      {isDiscountApplied && (
        <>
          <p style={{ marginTop: "10px" }}>Desconto Aplicado!</p>
          <button onClick={handleCancelDiscount}>Cancelar Desconto</button>
        </>
      )}

      <div className="carrinho-valores-container">
        <div>Total: R${discountedTotal.toFixed(2)}</div>
      </div>

      <div className="progress-btns-container">
        <button onClick={onPrev}>Voltar</button>
        <button onClick={handleConfirmOrder}>Confirmar pedido</button>
      </div>
    </div>
  );
};

export default ReviewOrder;